

// landing page 
export const homeObjOne = {
  lightBg: true,
  lightText: false,
  lightTopLine: false,
  lightTextDesc: false,
  topLine: 'View Our Services and Products ',
  headline: 'Shop our services and recommended products',
  description:
    'We offer Appliance Repair, maintenance, replacement and of course you can DIY on our youtube channel "please subscribe!" We offer recommendations on a large selection of appliances, maintenance products including that fridge filter .',
  buttonLabel: 'Shop Now',
  imgStart: '',
  img: require('./images/shoppingcart.jpg'),
  alt: 'Credit Card',
  linkto:'./dashboard'
};

export const homeObjTwo = {
  lightBg: false,
  lightText: true,
  lightTopLine: true,
  lightTextDesc: true,
  topLine: '100% Secure',
  headline: 'Stay protected with no downtime 24/7',
  description:
    'We have you covered no matter where you are located. ',
  buttonLabel: 'Learn More',
  imgStart: '',
  img: require('./images/googlesec.png'),
  alt: 'Vault',
  linkto:'./login'
  
};
//Replacment
export const homeObjThree = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Appliance Replacment',
  headline: 'Sometimes it is better to replace than repair',
  description:
    "We all dread the day one of our major appliances get to the age it is more cost effective to buy a new one instead of repairing it.  The cost is high and we want to get the most bang for our buck check out our recommendations on appliances.  We will point you in the right direction.  Check out the appliances we have available to purchase along with many other products.",
  buttonLabel: 'Become A Member',
  imgStart: 'start',
  img: require('./images/appliancetrash.jpg'),
  alt: 'Vault',
  linkto:'./login'
};
// maintance page top
export const homeObjFour = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'The power of Preventive Maintenance',
  headline: 'Everyone should think about a little Preventive Maintenance.',
  description:
    'The appliances in our home do require maintenance to ensure you can get the most life and efficiency from them, we offer some basic maintenance videos on our youtube channel, or if you want us to come and check all your appliances we do offer maintenance packages for appliances.',
  buttonLabel: 'Find Out More',
  imgStart: 'start',
  img: require('./images/preventmain.jpg'),
  alt: 'Vault',
  linkto:'./login'
};
// landing page
export const homeObjFive = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Live Online Appliance Repair',
  headline: 'Now Offering Virtual Diagnostic and Repair',
  description:

  "In keeping each other safe we provide a virtual online diagnostic to troubleshoot the problem you are having.  In many cases most appliance owners will be able to perform repairs on their own with the technician support and save money.  If a professional is needed to complete the repair and you are within the Hampton Roads area we can get parts ordered and schedule your in-home repair.  All initial virtual fees will roll into to total cost of repair.",




   
  buttonLabel: 'Virtual Diagnostic',
  imgStart: '',
  img: require('./images/virtual.jpg'),
  alt: 'Credit Card',
  start: '',
  linkto:'./seo'
};
// Appliance Repair page
export const homeObjSix = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Appliance Repair',
  headline: 'Put your mind at ease, and join the 7 Cities Team!',
  description:
    "Our appliances are important to us.  When they start to make strange noises or breakdown, it disrupts our family life. We can help here at 7 cities appliance we keep the appliances in your home at their best.",
  buttonLabel: 'Get Started',
  imgStart: '',
  img: require('./images/robot.jpg'),
  alt: 'Vault',
  start: '',
  linkto:'./login'
};
// millitary discount
export const homeObjSeven = {
  primary: false,
  lightBg: true,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Military & First Responders',
  headline:
    'We love the ones that are there for us in our time of need, the ones that keep us safe.  We salute you!',
  description:
    "We give all our military and first responders 10% off all services.",
  buttonLabel: 'Thank you for your service',
  imgStart: 'start',
  img: require('./images/flag.jpg'),
  alt: 'Vault',
  start: 'true',
  linkto:'./login'
};
// appliance repair page service
export const homeObjEight = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'What We Service',
  headline: 'We service all major appliance brands.',
  description:
    'Whirlpool, LG, Samsung, Frigidaire, KitchenAid, GE, Bosch, Jenn-Air, Maytag, Thermador, Electrolux, Kenmore, Viking, and many More.  ',
  buttonLabel: 'Sign Up Now',
  imgStart: 'start',
  img: require('./images/logobrands.png'),
  alt: 'Vault',
  start: 'true',
  linkto:'./login'
};

// DIY page top
export const homeObjNine = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Virtual Apliance Repair',
  headline: 'Appliance DIY Virtiual Help',
  description:
     "We now offer a virtual diagnostic.  The ability to have a technician on a video call as you explain what issue you are having.  For those that are not local to the Hampton Roads area we will be able to help you decide whether to repair or replace your appliance.  For DIYers we will be able to assist in ordering necessary parts for the repair and have them delivered to your home, and also offer live technical support.  The technician will walk you through some easy troubleshooting steps which you will need minor tools on hand to perform.",
  buttonLabel: 'Start your repair only 49.00',
  imgStart: 'start',
  img: require('./images/seohead.jpg'),
  alt: 'Vault',
  start: 'true',
  linkto:'./login'
};